import Keycloak, { KeycloakInitOptions } from 'keycloak-js';
import {
  getKeycloakAuthServerUrl,
  getKeycloakClientId,
  getKeycloakRealm
} from '../../utils/loginProvider';
import { clearAccessTokenLocalStorage, setAccessTokenLocalStorage } from '../../utils/token';

const keycloakClient = new Keycloak({
    url: getKeycloakAuthServerUrl(),
    realm: getKeycloakRealm(),
    clientId: getKeycloakClientId()
});

const createKeycloakClient = () => keycloakClient;

const initOptions: KeycloakInitOptions = {
    flow: 'standard',
    // silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
    checkLoginIframe: false,
    pkceMethod: 'S256'
};

const syncKeycloakAccessToken = async (minValidity = 30): Promise<string | undefined> => {
    if (!keycloakClient.authenticated) return keycloakClient.token;

    try {
        await keycloakClient.updateToken(minValidity);
        if (keycloakClient.token) {
            setAccessTokenLocalStorage(keycloakClient.token);
        }

        return keycloakClient.token;
    } catch {
        clearAccessTokenLocalStorage();
        return undefined;
    }
};

export {
    keycloakClient,
    createKeycloakClient,
    syncKeycloakAccessToken,
    initOptions
};
